import React, { ComponentPropsWithRef, PropsWithChildren } from "react";
import InfiniteScroll from "react-infinite-scroll-component";

export interface Props
  extends PropsWithChildren<ComponentPropsWithRef<"table">> {
  children?: React.ReactNode;
  data?: Array<any>;
  refetchNextData?: Function;
  hasMore?: boolean;
  noEndMsg?: boolean;
}
type Ref = HTMLDivElement;

const Table = React.forwardRef<Ref, Props>((props, ref) => {
  return (
    <>
      {props.data ? (
        <div
          className={props.className}
          id="main-table"
          data-testid="table"
          ref={ref}
        >
          <InfiniteScroll
            dataLength={props.data?.length || 0}
            data-testid="infinite-scroll"
            next={async () => {
              if (props.refetchNextData) await props.refetchNextData();
            }}
            hasMore={props.hasMore ? props.hasMore : false}
            loader={<h4 className="flex justify-center">Loading...</h4>}
            endMessage={
              <>
                {props.data && !props.noEndMsg ? (
                  <div className="flex justify-center pt-4 pb-10 opacity-50 text-sm">
                    <b>
                      {props.data.length > 0 ? "- End of list -" : "No data"}
                    </b>
                  </div>
                ) : null}
              </>
            }
            scrollableTarget="main-table"
            scrollThreshold={0.99}
          >
            <table>{props.children}</table>
          </InfiniteScroll>
        </div>
      ) : (
        // Temp solution
        <div {...props} ref={ref}>
          <table>{props.children}</table>
        </div>
      )}
    </>
  );
});

export default Table;
